module.exports = __webpack_public_path__ + "static/media/emeraldairlines.1668c5d2.png";